/*
 * @Author: ken yang
 * @Date: 2022-10-08 14:06:46
 * @LastEditTime: 2025-06-18 10:36:04
 * @LastEditors: ken yang
 * @Description: 钱包接口
 * @FilePath: /uexch_h5/src/api/wallet.js
 */
import { useReq } from '@/utils/request/useReq'
import axios from '@/utils/request'

const commonCoinListUrl = '/asset/common/coinList'
const commonCoinList = async (body) => {
  const { data } = await axios.post(commonCoinListUrl, body || {})
  return data.data
}

const otherRecordUrl = '/account/query/other-record'
const otherRecord = (params = {}, options = {}) =>
  useReq(otherRecordUrl, { method: 'POST', data: params }, { immediate: false, ...options })

const needLoginUrl = [otherRecordUrl]
export default {
  needLoginUrl,
  commonCoinList,
  otherRecord,
}
